import { Module } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import RootState from '@vue-storefront/core/types/RootState'
import IPayPaymentState from '../../types/IPayPaymentState'

export const widget: Module<IPayPaymentState, RootState> = {
  namespaced: true,
  state: {
    widgetSessionId: ''
  },
  getters,
  actions,
  mutations
}
